export default "__VITE_ASSET__2e4380c7__"